const PASSWORD_PAGE_SELECTORS = {

};

class templatePasswordJS {
    constructor() {
        this.checkForSubmission();
    }

    checkForSubmission(){
        let windowURL = window.location.href;
        let triggerLoginModal = Utility.DomSelector.$('[data-modal-opener="password-modal"]');
        const passwordModal = Utility.DomSelector.byId('password-modal');
        if(windowURL.indexOf('?login_attempt') > -1){
            openModal(passwordModal, triggerLoginModal);
        }
    }
}

typeof templatePasswordJS !== 'undefined' && new templatePasswordJS()